import { FlexCol, FlexRow } from '@/components/common/Flex';
import { isChildPresent } from '@/util/react';
import { FlexProps } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { Header, Paragraph } from '../Typography';

export interface BasicModalLayoutProps
    extends Omit<FlexProps, 'title' | 'content'> {
    title: ReactNode;
    subtitle?: ReactNode;
    headerProps?: FlexProps;
    content?: ReactNode;
    contentProps?: FlexProps;
    footer?: ReactNode;
    footerProps?: FlexProps;
}

const BasicModalLayout = ({
    title,
    subtitle,
    headerProps = {},
    content,
    contentProps = {},
    footer,
    footerProps = {},
    minH = 500,
    ...props
}: BasicModalLayoutProps) => {
    return (
        <FlexCol minH={minH} {...props}>
            <FlexCol mb={10} {...headerProps}>
                <Header>{title}</Header>
                {isChildPresent(subtitle) && (
                    <Paragraph mt={4} color="textMuted">
                        {subtitle}
                    </Paragraph>
                )}
            </FlexCol>
            <FlexRow grow={1} {...contentProps}>
                {content}
            </FlexRow>
            <FlexRow justify="space-between" {...footerProps}>
                {footer}
            </FlexRow>
        </FlexCol>
    );
};

export default BasicModalLayout;
